/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { batchCreateContactResultDtoSchema } from "./batchCreateContactResultDtoSchema";
import { z } from "zod/v4";

export const batchCreateContactsResponseDtoSchema = z.object({
    get "results"(){
                return z.array(batchCreateContactResultDtoSchema)
              }
    })